import { AgentSkillsPage } from "@/components/agents/tabs/agent-skills";
import { DiscordPage } from "@/components/agents/tabs/analyst-discord";
import { EmailPage } from "@/components/agents/tabs/analyst-email";
import { MeetingsPage } from "@/components/agents/tabs/analyst-meetings";
import { WhatsAppPage } from "@/components/agents/tabs/analyst-whatsapp";
import { TriageLearningsPage } from "@/components/agents/tabs/log-triage-learnings";
import { LogSourcesPage } from "@/components/agents/tabs/log-triage-sources";
import { CoderLearningsPage } from "@/components/agents/tabs/metodej-learnings";
import { ReviewerLearningsPage } from "@/components/agents/tabs/reviewer-learnings";
import { ProkopRulesPage, VratislavLearningsPage } from "@/components/agents/tabs/rule-learnings";
import { TesterLearningsPage } from "@/components/agents/tabs/tester-learnings";
import { WikiKeeperPassesPage } from "@/components/agents/tabs/wiki-keeper-passes";
import type { ComponentType } from "react";

export type AgentExtraTab = { segment: string; label: string; Component: ComponentType };

/** The surfaces an agent owns beyond the common tabs: his inputs and what he learned. */
export const AGENT_EXTRA_TABS: Record<string, AgentExtraTab[]> = {
  analyst: [
    { segment: "email", label: "Email", Component: EmailPage },
    { segment: "whatsapp", label: "WhatsApp", Component: WhatsAppPage },
    { segment: "discord", label: "Discord", Component: DiscordPage },
    { segment: "meetings", label: "Meetings", Component: MeetingsPage },
  ],
  metodej: [
    { segment: "learnings", label: "Learnings", Component: CoderLearningsPage },
    { segment: "skills", label: "Skills", Component: AgentSkillsPage },
  ],
  reviewer: [{ segment: "learnings", label: "Learnings", Component: ReviewerLearningsPage }],
  tester: [
    { segment: "capabilities", label: "Missing capabilities", Component: TesterLearningsPage },
    { segment: "rules", label: "Rules", Component: ProkopRulesPage },
  ],
  vratislav: [{ segment: "learnings", label: "Learnings", Component: VratislavLearningsPage }],
  "log-triage": [
    { segment: "sources", label: "Sources", Component: LogSourcesPage },
    { segment: "learnings", label: "Learnings", Component: TriageLearningsPage },
  ],
  "wiki-keeper": [{ segment: "passes", label: "Passes", Component: WikiKeeperPassesPage }],
};
